import { render, staticRenderFns } from "./date-filter.vue?vue&type=template&id=2bfc61c0&scoped=true&"
import script from "./date-filter.vue?vue&type=script&lang=js&"
export * from "./date-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc61c0",
  null
  
)

export default component.exports